const state = () => ({
    settings: {
        sysLang: null,
        autoPrint: 'N',
        autoAudYn: 'N',
        braille: null,
        code: null,
    },
    copyData: [],
    cutData: [],
    showLoading: false
})

const getters = {
    getSettings: (state) => state.settings,
    getCopyData: (state) => state.copyData,
    getCutData: (state) => state.cutData,
    getShowLoading: (state) => state.showLoading,
}

const mutations = {
    setCopyData(state, data) {
        state.copyData = data
        state.cutData = []
    },
    setCutData(state, data) {
        state.copyData = []
        state.cutData = data
    },
    setSettings(state, data) {
        state.settings = data
    },
    setShowLoading(state, data) {
        state.showLoading = data
    }
}

const actions = {

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
